module.exports = __webpack_public_path__ + "img/smartphone-pointer.dc6d7823.png";